import { render } from "./gestionmantenimiento.vue?vue&type=template&id=51a66547&scoped=true"
import script from "./gestionmantenimiento.vue?vue&type=script&lang=js"
export * from "./gestionmantenimiento.vue?vue&type=script&lang=js"

import "./gestionmantenimiento.vue?vue&type=style&index=0&id=51a66547&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a66547"]])

export default __exports__